<template>
    <div class="bankruptcy">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <!-- <h3 class="mb-0">Bankruptcy</h3> -->
                  <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                           Bankruptcy
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_bankruptcy_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
            </b-card-header>
            <div v-if="tableData.length > 0" class="rounded-bottom">
                <el-table
                :data="tableData"
                style="width: 100%">
                    <el-table-column
                        prop="legal_case_case_type"
                        label="Case Type"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="text-break top-line">{{ scope.row.legal_case_case_type }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="legal_case_plaintiff"
                        label="Plaintiff"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="text-break top-line">{{ scope.row.legal_case_plaintiff || '-' }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="legal_case_subject_comment"
                        label="Subject Comment"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="text-break top-line">{{ scope.row.legal_case_subject_comment }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="bg-light p-3 text-center rounded-bottom">
                <p class="text-xs">No Bankruptcy proceeding listed</p>
            </div>
        </b-card>
           <BankruptcyModal
            :bankruptcy="bankruptcy" 
            :bankruptcy-legal-cases="bankruptcyLegalCases"
            :show_bankruptcy_full_view.sync="modals.show_bankruptcy_full_view"
        />
    </div>
</template>
<script>
    import { Table, TableColumn } from 'element-ui'
    import BankruptcyModal from '@/views/CustomerProfile/CustomerModals/BankruptcyModal.vue'

    export default {
        name: 'bankruptcy',
        props: {
            bankruptcy: {
                type: Array,
                default: () => []
            },
            bankruptcyLegalCases: {
                type: Array,
                default: () => []
            }
        },        
        components: {
            BankruptcyModal,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.bankruptcy,
                modals: {
                  show_bankruptcy_full_view: false
                }
            }
        },
    }
</script>